// src/utils/notify.js
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CountdownCircle from "./CountdownCircle"; // مكون العد التنازلي الدائري

export const notify = {
  success: (msg, options = {}) =>
    toast.success(msg, { position: "top-right", autoClose: 2500, ...options }),

  error: (msg, options = {}) =>
    toast.error(msg, { position: "top-right", autoClose: 3500, ...options }),

  info: (msg, options = {}) =>
    toast.info(msg, { position: "bottom-right", autoClose: 3000, ...options }),

  warning: (msg, options = {}) => {
    const {
      autoClose = 5000,      // الوقت الافتراضي للاغلاق
      showCountdown = false, // هل نعرض الدائرة
      closeOnUserActivity = false,
      theme = "light",
    } = options;

    if (showCountdown) {
      toast(
        <CountdownCircle
          message={msg}
          duration={autoClose}
          closeOnUserActivity={closeOnUserActivity}
          theme={theme}
        />,
        { autoClose: autoClose, closeOnClick: false }
      );
    } else {
      toast.warning(msg, { autoClose, position: "top-right", theme });
    }
  },
};
